// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--alNoM","icon":"_02712f2b3b--icon--s3JV2","black-friday-badge":"_02712f2b3b--black-friday-badge--nh8Hd"};